import { observable } from 'shared/utilities/observable';
import React from 'react';
import { UiButton } from 'shared/uikit-new';
import { COLORS } from 'shared/constants';

const store = observable({
    isOpened: false,
    title: '',
    description: '',
    resolve: (value: boolean) => {},
    actions: (resolve: (value: boolean) => void ) => [] as React.ReactNode[],
});

type OptionsType = {
    title?: string;
    description?: string;
    actions?: (resolve: (result: boolean) => void) => React.ReactNode[];
};

export const notifier = () => {
    return {
        store,
        alert: async (options: OptionsType) => {
            return new Promise(_resolve => {
                const resolve = (result: boolean) => {
                    store.set('isOpened', false);
                    _resolve(result);
                };

                store.update({
                    title: options?.title || '',
                    description: options?.description || '',
                    actions: options?.actions ? options.actions : resolve => [
                        <UiButton
                            key="accept"
                            onClick={() => resolve(true)}
                            style={{
                                backgroundColor: [COLORS._2C2F35, COLORS._2C2F35],
                                color: [COLORS._FFFFFF, COLORS._858991],
                            }}
                        >
                            Принять
                        </UiButton>,
                    ],
                    resolve,
                    isOpened: true,
                });
            });
        },
        confirm: async (options: OptionsType) => {
            return new Promise(_resolve => {
                const resolve = (result: boolean) => {
                    store.set('isOpened', false);
                    _resolve(result);
                };
                store.update({
                    title: options?.title || '',
                    description: options?.description || '',
                    actions: options?.actions ? options.actions : resolve => [
                        <UiButton
                            key="cancel"
                            onClick={() => resolve(false)}
                            style={{
                                backgroundColor: [COLORS._F3F5F8, COLORS._C6CAD1],
                                color: [COLORS._2C2F35, COLORS._2C2F35],
                            }}
                        >
                            Отменить
                        </UiButton>,
                        <UiButton
                            key="accept"
                            onClick={() => resolve(true)}
                            style={{
                                backgroundColor: [COLORS._2C2F35, COLORS._2C2F35],
                                color: [COLORS._FFFFFF, COLORS._858991],
                            }}
                        >
                            Принять
                        </UiButton>,
                    ],
                    resolve,
                    isOpened: true,
                });
            });
        },
    };
};
